module.exports = __webpack_public_path__ + "img/ico_select.01b5fa54.svg";